import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { type Err } from './types'

export type UseCreateActivityTagProps = Readonly<{
  onCreated: () => void
  onError: (error: Err) => void
}>

export type UseCreateActivityTagReturn = Readonly<{
  isLoading: boolean
  createActivityTag: (name: string) => void
}>

const defaultError: Err = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useCreateActivityTag = ({ onCreated, onError }: UseCreateActivityTagProps): UseCreateActivityTagReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: createVolunteeringActivity }] = useMutation(
    workplaceGivingService.createVolunteeringActivity,
    () => {
      onCreated()
    },
    error => {
      onError(error?.response?.data?.error ?? defaultError)
    }
  )

  return {
    isLoading,
    createActivityTag: (name: string) => {
      createVolunteeringActivity({ name })
    }
  }
}
